import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function GoogleAdsIcon(props: IconProps) {
  const id = useId();

  return (
    <Icon viewBox="0 0 20 19" {...props}>
      <Box as="g" clipPath={`url(#google-a-${id})`}>
        <Box
          as="path"
          fill="#FBBB04"
          fillRule="evenodd"
          d="M6.467 2.912a3345.9 3345.9 0 0 0-5.092 8.83c-.237.412-.451.78-.478.815-.04.056-.063.126-.04.126a3.1 3.1 0 0 0 .165-.157c.747-.733 1.583-1.078 2.511-1.037 1.804.082 3.18 1.5 3.183 3.281 0 .384-.097.961-.192 1.133-.026.048-.032.114-.01.114.008 0 .028-.028.046-.062.017-.034.102-.182.188-.33.086-.146.554-.953 1.04-1.792.485-.838.997-1.72 1.137-1.958a81.274 81.274 0 0 0 1.091-1.895c0-.035-.896-1.6-2.197-3.838A51.674 51.674 0 0 1 7.056 4.8a3.32 3.32 0 0 1-.282-2.198 2.66 2.66 0 0 0 .054-.296c-.003-.004-.166.27-.361.606Z"
          clipRule="evenodd"
        />
        <Box
          as="path"
          fill="#34AC53"
          fillRule="evenodd"
          d="M3.068 11.501c-.774.088-1.422.412-2.046 1.025a1.578 1.578 0 0 1-.173.157c-.022 0-.265.393-.378.61-.986 1.904.12 4.267 2.208 4.722 1.246.271 2.455-.125 3.24-1.064.257-.306.602-.87.585-.957a.157.157 0 0 1 .019-.089c.192-.347.246-1.255.11-1.878-.345-1.583-1.936-2.71-3.565-2.526Z"
          clipRule="evenodd"
        />
        <Box
          as="path"
          fill="#3C8CDB"
          fillRule="evenodd"
          d="M9.575.02a3.307 3.307 0 0 0-2.433 1.622c-.129.22-.275.545-.293.65-.006.036-.034.175-.062.308a3.193 3.193 0 0 0 .14 1.883c.101.265.2.444.948 1.734 1.596 2.75 2.152 3.724 2.153 3.766 0 .014.057.12.125.234.068.114.187.317.263.45l.507.879a2361.185 2361.185 0 0 1 2.782 4.829 3.333 3.333 0 0 0 3.9 1.567c1.756-.534 2.737-2.472 2.134-4.215-.117-.337-.204-.494-1.928-3.49a680.438 680.438 0 0 1-.703-1.22l-1.37-2.375-1.391-2.409c-.4-.685-1.017-1.767-1.372-2.408-.724-1.308-2-1.985-3.4-1.806Z"
          clipRule="evenodd"
        />
        <Box
          as="path"
          fill="#819D8C"
          fillRule="evenodd"
          d="M6.704 3.55c0 .032.003.045.008.03a.136.136 0 0 0 0-.06c-.005-.015-.008-.002-.008.03Z"
          clipRule="evenodd"
        />
      </Box>
      <Box as="defs">
        <clipPath id={`google-a-${id}`}>
          <Box as="path" fill="#fff" d="M0 0h20v18.15H0z" />
        </clipPath>
      </Box>
    </Icon>
  );
}
